import React from "react";
import { VStack, Text, Flex, Skeleton } from "@chakra-ui/react";

import { FormattedMoney } from "components/FormattedMoney";

/**
 * ItemRow - Row of transaction data with title/value that handles if a divider is shown or not
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.value
 * @param {string} props.currency
 * @param {Icon} [props.leftValueIcon]
 * @param {boolean} [props.capitalizeValue = false]
 * @param {boolean} [props.boldTitle = false]
 * @param {boolean} [props.boldValue = false]
 * @param {boolean} [props.isSkeleton = false]
 * @returns JSX.Element
 */
export default function ItemRow({
  title,
  value,
  currency,
  leftValueIcon,
  capitalizeValue = false,
  boldTitle = false,
  boldValue = false,
  isSkeleton = false,
  subtitle = "",
}) {
  return (
    <VStack data-testid="item-row" align="stretch">
      <Flex justify="space-between">
        <Skeleton flex={1} isLoaded={!isSkeleton}>
          <Text fontSize={boldTitle ? "md" : "sm"} fontWeight={boldTitle ? "bold" : "medium"}>
            {title || ""}
          </Text>
        </Skeleton>
        <Flex flex={1} align="center" justify="flex-end">
          {leftValueIcon}
          <Skeleton isLoaded={!isSkeleton}>
            <Text
              textTransform={capitalizeValue ? "capitalize" : "none"}
              textAlign="right"
              fontSize={boldValue ? "md" : "sm"}
              fontWeight={boldValue ? "bold" : "normal"}
              sx={{ wordBreak: "break-all" }}
            >
              {currency ? <FormattedMoney value={value} currency={currency} /> : value || ""}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>
      {subtitle}
    </VStack>
  );
}
